import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class OwnerGuard {

  public static redirectToFunc(rejectedPermissionName: string, activateRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot): object {
    return {
      navigationCommands: ['403'],
      navigationExtras: {
        skipLocationChange: false
      }
    };
  }

  public static ownerPermissions(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): string[] {
    const id = route.params['id'] || route.parent.params['id'];
    const roleId = OwnerGuard.swapCase(id);
    return roleId ? [`ROLE_OWNER_${roleId}`] : [];
  }

  public static swapCase(str: string) {
    if (!str) {
      return '';
    }
    return str.replace(/([a-z]+)|([A-Z]+)/g, function (match, chr) {
      return chr ? match.toUpperCase() : match.toLowerCase();
    });
  }
}
